import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Actions, DealsActionData } from 'src/app/pages/dashboards/clients/interface/data.interface';
import { ModalNewActivitiComponent } from '../modal-new-activiti/modal-new-activiti.component';
import { MatTableDataSource } from '@angular/material/table';
import { ModalEditTagsDealsComponent } from '../modal-edit-tags-deals/modal-edit-tags-deals.component';

@Component({
  selector: 'app-detail-deal',
  templateUrl: './detail-deal.component.html',
  styleUrls: ['./detail-deal.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DetailDealComponent {
  @Output() dealUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
  public dataDeal: DealsActionData;
  public dataSource: MatTableDataSource<Actions>;
  columnsToDisplay = ['name', 'status', 'resolutionComment','creationDate', 'requestingUser', 'tags'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedElement: Actions | null;

  constructor(private cdr: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA)public data: any, private dialog: MatDialog, private dialogRef: MatDialogRef<DetailDealComponent>) {
    this.dataDeal = data;
    this.dataSource = new MatTableDataSource<Actions>([]);
  }

  ngOnInit() {
    if (this.data && Array.isArray(this.data.actions)) {
      const sortedActions = this.data.actions.sort((b: any, a: any) => {
        const dateA = new Date(a.creationDate).getTime();
        const dateB = new Date(b.creationDate).getTime();
        return dateB - dateA;
      });
      this.dataSource.data = sortedActions;
    }
  }

  public openModalNewActiviti(data: any) {
    this.dataDeal.actions = data;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '56vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '80vw';
    dialogConfig.maxHeight = '80vh';
    dialogConfig.data =  this.dataDeal;
    var ref = this.dialog.open(ModalNewActivitiComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      this.dealUpdated.emit(true);
    });
  }

  public updateDeals(updatedDeals: any) {
    if (updatedDeals) {
      const deal = updatedDeals.find((action: any) => action.id === this.dataDeal.dealId);
      
      if (deal) { // Verifica que deal no sea undefined
        this.dataSource.data = deal.actions; 
        this.cdr.detectChanges();
      } else {
        console.error(`No se encontró un trato con el ID ${this.dataDeal.dealId}.`);
      }
    } else {
      console.error("No se pudieron actualizar los tratos. Datos no válidos.");
    }
  }

  public abrirModalTags(data: any) {
    this.dataDeal.actions = data;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '52vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '60vw';
    dialogConfig.maxHeight = '60vh';
    dialogConfig.data =  this.dataDeal;
    var ref = this.dialog.open(ModalEditTagsDealsComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      this.dealUpdated.emit(true);
    });
  }

}
